<template>
  <div>
    <!-- class="title-banner" -->
    <div :style="headStyle">
      <navBar ref="navBar" />
    </div>
    <keep-alive>
      <router-view />
    </keep-alive>
    <Footer id="contact" />
        
    <div
      v-if="!isMobile"
      class="hover-button"
    >
      <img
        src="../assets/images/favicon.png"
        alt="primihub"
      >
      <div>联系我们</div>
      <div class="hover-right-box">
        <div class="flex">
          <div>
            <img
              src="../assets/images/hoverbox/phone.png"
              alt="primihub"
            >
          </div>
          <div>
            <p>400-7788-685</p>
            <p>18515152260（李先生）</p>
          </div>
        </div>
        <div class="flex">
          <div>
            <img
              src="../assets/images/hoverbox/email.png"
              alt="primihub"
            >
          </div>
          <div>
            <p>商务合作邮箱</p>
            <p>business@primihub.com</p>
          </div>
        </div>
        <div class="flex">
          <div>
            <img
              src="../assets/images/hoverbox/pencil.png"
              alt="primihub"
            >
          </div>
          <div>
            <p>需求在线填写</p>
            <p class="online-form">
              <a
                href="https://wenjuan.feishu.cn/m/cfm?t=s2iIFHH2eeLi-8dnx"
                target="_blank"
              >在线填写</a>(我们将第一时间回复您)
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import navBar from "./navBar/navBar.vue";
import Footer from '@/components/Footer'
import { mobileMixins } from '@/mixins/mobile';
export default {
    components: {
        navBar,
        Footer,
    },
    mixins:[mobileMixins],
    data() {
        return {
            headStyle:{
                'width': "100%",
                'z-index': '9999',
                'position':'fixed',
                'height': '74px',
                'top':'0px',
                background:"transparent"
            }
        };
    },
    // watch:{
    //     '$route.path'(val){
    //         console.log('当前的路由dizhi :',val)
    //     }
    // },
    mounted(){
        window.addEventListener("scroll", this.handleScroll);
    },
    
    beforeDestroy() {
        window.removeEventListener("scroll", this.handleScroll);
    },
    methods: {
        handleScroll(){
            let scrollTop =
                window.pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop;
            //设置背景颜色的透明度
            if (scrollTop) {
                this.headStyle.background = `rgba(28, 28, 28,${scrollTop / (scrollTop + 80)})`;
                this.headStyle.color = `rgba(0, 0, 0,${scrollTop / (scrollTop + 80)})`;
            } else if (scrollTop == 0) {
                this.headStyle.background = "rgba(0, 0, 0, 0)";
                this.headStyle.color = "#FFFFFF";
            }
        },
        handleFreeClick() {
            this.$router.push({ path: "/apply" });
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        },
    },
    
};
</script>
<style scoped lang="scss">
.title-banner {
    width: 100%;
    position: relative;
    z-index: 10;
    position:sticky;
    height: 74px;
    margin-top:-74px;
    top:0px;
}
.hover-button{
    width: 80px;
    height: 80px;
    position: fixed;
    z-index: 10;
    right:210px;
    bottom: 175px;
    background: #fff;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-shadow: 0px 0px 16px 0px #CADBEF;
    border: 1px solid #E9F1F8;  
    &:hover .hover-right-box{
        display: block;
    }
    .hover-right-box{
        display: none;
        position: absolute;
        width: 269px;
        height: 204px;
        border-radius: 5px;
        background: #fff;
        box-shadow: 0px 0px 16px 0px #CADBEF;
        left: -295px;
        top: -35px;
        &::after{
            content: '';
            display: inline-block;
            width: 100px;
            height: 100px;
            background: transparent;
            position: absolute;
            right: -100px;
            top: 10px;
        }
        .flex{
            justify-content: flex-start;
            margin: 20px 0px;
            div{
                text-align: left;
                align-self: center;
                margin-left: 24px;
                p{
                    margin-bottom: 0px;
                    line-height: 1.3;
                }
            }
            .online-form{
                font-size: 12px;
                color: #AEB0BA;
                a{
                    font-size: 14px;
                    color: #0d6efd;
                }
            }

        }
    }
}

</style>
